var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 150,
    viewBox: "0 0 117 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.42066 44.4164L77.1378 1.76501C80.046 0.0824186 83.7674 1.07596 85.4499 3.984L143.77 104.783C144.612 106.237 144.115 108.099 142.661 108.94C142.167 109.226 141.601 109.366 141.03 109.346L89.119 107.504L64.844 153.426C64.059 154.911 62.2188 155.479 60.7335 154.694C60.2282 154.426 59.8086 154.023 59.5222 153.528L1.20168 52.7284C-0.480859 49.8204 0.512627 46.0989 3.42066 44.4164Z",
    fill: "#DED2D2",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.ee25c037fab0148bb5bc59ad45d9ccb5.svg";
export { ForwardRef as ReactComponent };